import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { PendingReportScreen } from '@/features/purchasing-landed-costs/pending-report'
import type { PendingReportFilters } from '@/features/purchasing-landed-costs/pending-report-api'
import { hasGrant } from '@/lib/me'

/** Route shell for the landed costs pending report. */
export const Route = createFileRoute('/_authenticated/purchasing/reports/landed-costs-pending')({
  validateSearch: (search: Record<string, unknown>): PendingReportFilters => ({
    category: typeof search.category === 'string' && search.category ? search.category : undefined,
    supplier: typeof search.supplier === 'string' && search.supplier ? search.supplier : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'landed_cost.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: LandedCostsPendingRoute,
})

function LandedCostsPendingRoute() {
  const navigate = useNavigate()
  const params = Route.useSearch()

  return (
    <PendingReportScreen
      params={params}
      onParamsChange={(next) =>
        void navigate({ to: '/purchasing/reports/landed-costs-pending', search: next })
      }
    />
  )
}
